import React, {PureComponent} from "react";
import baseMethods from "../../../api/baseMethods";
import "./header.scss";
import "antd/dist/antd.css";
import commodityApi from "../../../api/commodity/commodity";

class Product extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            commodityMove: [],
            commodityCategories: null,
            commodityMovediv: "",
            commodityState: false,
            commodityList: [],
            commodityNew: [],
        };
    }

    componentDidMount() {
        this.reqCommodityCategories();
    }

    /*获取商品分类*/
    reqCommodityCategories = () => {
        commodityApi.commodity_categories().then((res) => {
            if (res && res.length > 0) {
                let temp_commodity_all = JSON.parse(JSON.stringify(res));
                temp_commodity_all.unshift({
                    name: "推荐",
                    products: [],
                    children: [],
                });
                let commo_count = 0;
                temp_commodity_all.map(async (item, index) => {
                    item["products"] = await this.reqCommodityList(item["uuid"]);
                    item["children"] = await this.reqCommoCategoriesLevel2(item["uuid"]);
                    commo_count += 1;
                    if (commo_count === temp_commodity_all.length) {
                        this.setState(
                            {
                                commodityCategories: "",
                            },
                            () => {
                                this.setState({
                                    commodityCategories: temp_commodity_all,
                                });
                            }
                        );
                    }
                });

                console.log('temp_commodity_all', temp_commodity_all);
            }
        });
    };
    /*获取商品分类--二级*/
    reqCommoCategoriesLevel2 = (commo_id) => {
        return new Promise((resolve, reject) => {
            commodityApi
                .commodity_categories(commo_id)
                .then((res) => {
                    if (res && res.length > 0) {
                        let temp_commo_all = JSON.parse(JSON.stringify(res));
                        let commo_count = 0;
                        temp_commo_all.map(async (item, index) => {
                            item["products"] = await this.reqCommodityList(item["uuid"]);
                            commo_count += 1;
                            if (commo_count === temp_commo_all.length) {
                                resolve(temp_commo_all);
                            }
                        });
                    } else {
                        resolve([]);
                    }
                })
                .catch(() => {
                    resolve([]);
                });
        });
    };

    /*获取商品列表*/
    reqCommodityList = (uuid) => {
        return new Promise((resolve, reject) => {
            commodityApi
                .commodityListPage(uuid)
                .then((res) => {
                    if (res && res.length > 0) {
                        resolve(res);
                    } else {
                        resolve([]);
                    }
                })
                .catch(() => {
                    resolve([]);
                });
        });
    };

    //去重
    commodityBack = (data) => {
        for (let i = 0; i < data.length; i++) {
            for (let j = i + 1; j < data.length; j++) {
                if (data[i]["uuid"] === data[j]["uuid"]) {
                    data.splice(j, 1);
                    j = j - 1;
                }
            }
        }
    };
    // 总览数据
    commodityFun = (data) => {
        for (let index = data[0].children ? 1 : 0; index < data.length; index++) {
            let length = data[index].products.length;
            let childLength = data[index].children
                ? data[index].children.length
                : data[index].products.length;
            for (let i = 0; length === 0 ? i < childLength : i < length; i++) {
                let val =
                    data[index].products.length !== 0
                        ? data[index].products[i]
                        : this.commodityFun(data[index].children);
                if (val) {
                    if (
                        val.hot === "1" &&
                        (val.newLaunch === "2" || val.newLaunch === null)
                    ) {
                        this.state.commodityList.push(val);
                    } else if (
                        val.newLaunch === "1" &&
                        (val.hot === "2" || val.hot === null)
                    ) {
                        this.state.commodityNew.push(val);
                    } else if (val.hot === "1" && val.newLaunch === "1") {
                        this.state.commodityList.push(val);
                    } else {
                        continue;
                    }
                }
            }
        }
        this.commodityBack(this.state.commodityList);
        this.commodityBack(this.state.commodityNew);
    };
    header_move = (e) => {
        let data = this.state.commodityCategories;
        this.setState(
            {
                commodityMove: [],
                commodityMovediv: "",
            },
            () => {
                // eslint-disable-next-line no-unused-expressions
                data[e].name === "推荐"
                    ? (this.setState({
                        commodityMovediv: e,
                        commodityState: false,
                    }),
                        this.commodityFun(data))
                    : this.setState(
                    {
                        commodityMove:
                            data[e].products.length === 0
                                ? data[e].children
                                : data[e].products,
                        commodityMovediv: e,
                        commodityState: data[e].children.length !== 0 ? true : false,
                        commodityNew: [],
                        commodityList: [],
                        commodityName: data[e].name,
                    },
                    () => {
                        // console.log(this.state.commodityState, data);
                    }
                    );
            }
        );
    };
    debounce = (func, wait, num) => {
        var that = this;
        clearTimeout(that.timer);
        if (that.flag) {
            if (!that.timer) {
                //第一次进入
                func(num);
            }
            that.timer = setTimeout(() => {
                that.timer = null;
            }, wait);
        } else {
            that.timer = setTimeout(() => {
                func(num);
            }, wait);
        }
    };
    show_commodity_menu = () => {
        let comm_menu = document.getElementById("commodity_list_menu_box");
        if (comm_menu) {
            this.header_move(0);
            comm_menu.style.height = "480px";
            comm_menu.style.border = "1px solid #E3E6EA";
        }
    };
    hide_commodity_menu = () => {
        let comm_menu = document.getElementById("commodity_list_menu_box");
        if (comm_menu) {
            comm_menu.style.height = "0";
            comm_menu.style.border = "none";
        }
    };

    render() {
        const {go_toFun} = this.props;
        const product_hot = () => {
            let hotArr =
                this.state.commodityList.length !== 0
                    ? this.state.commodityList
                    : this.state.commodityMove;
            return (
                <div className="product_div">
                    <div className="product_head">
                        <span>最热</span>
                        <img src={baseMethods.base_images_Url.header_hot} alt="hot"/>
                    </div>
                    <div className="product_val">
                        {hotArr.map((item, index) => {
                            return (item.state && item.shelf
                                && item.shelf === "1" &&
                                item.state === "1") ? (
                                <p key={index} onClick={go_toFun.bind(this, item.uuid)} className="product_item_hot">
                                    {item.name}
                                </p>
                            ) : null;
                        })}
                    </div>
                </div>
            );
        };
        const product_new = () => {
            let newArr =
                this.state.commodityNew !== 0
                    ? this.state.commodityNew
                    : this.state.commodityMove;
            return (
                <div className="product_div">
                    <div className="product_head">
                        <span>最新</span>
                        <img src={baseMethods.base_images_Url.header_new} alt="new"/>
                    </div>
                    <div className="product_val">
                        {newArr.map((item, index) => {
                            return (item.state && item.shelf
                                && item.shelf === "1" &&
                                item.state === "1") ? (
                                <p key={index} onClick={go_toFun.bind(this, item.uuid)} className="product_item_new">
                                    {item.name}
                                </p>
                            ) : null;
                        })}
                    </div>
                </div>
            );
        };
        const product_val = () => {
            let valArr = this.state.commodityMove;
            return valArr.length > 0 ? (
                <div className="product_div">
                    <div className="product_rightHead">{this.state.commodityName}</div>
                    <div className="product_val">
                        {valArr.map((item, index) => {
                            return (item.state && item.shelf
                                && item.shelf === "1" &&
                                item.state === "1") ? (
                                <div key={index} className="product_item_val">
                                    <p onClick={go_toFun.bind(this, item.uuid)}>{item.name}</p>
                                    {item.hot === "1" || item.newLaunch === "1" ? (
                                        <img
                                            src={
                                                item.hot === "1"
                                                    ? baseMethods.base_images_Url.header_hot
                                                    : item.newLaunch === "1"
                                                    ? baseMethods.base_images_Url.header_new
                                                    : ""
                                            }
                                            alt=""
                                            className="val_img"
                                        />
                                    ) : null}
                                </div>
                            ) : null;
                        })}
                    </div>
                </div>
            ) : (
                "暂无数据"
            );
        };
        const produc_child = () => {
            let childArr = this.state.commodityMove;
            return childArr.length !== 0
                ? this.state.commodityMove.map((item, index) => {
                    return (
                        <div className="product_div" key={index}>
                            <div className="product_head">
                                <span>{item.name}</span>
                            </div>
                            <div className="product_val">
                                {item.products.map((item, index) => {
                                    return (
                                        <div key={index}>
                                            {
                                                (item.state && item.shelf
                                                    && item.shelf === "1" &&
                                                    item.state === "1") ? <p onClick={go_toFun.bind(this, item.uuid)}>
                                                    {item.name}
                                                </p> : null
                                            }

                                            {item.hot === "1" || item.newLaunch === "1" ? (
                                                <img
                                                    src={
                                                        item.hot === "1"
                                                            ? baseMethods.base_images_Url.header_hot
                                                            : item.newLaunch === "1"
                                                            ? baseMethods.base_images_Url.header_new
                                                            : ""
                                                    }
                                                    alt=""
                                                    className="val_img"
                                                />
                                            ) : null}
                                        </div>
                                    );
                                })}
                            </div>
                        </div>
                    );
                })
                : "暂无数据";
        };
        const commodity_ele_list = this.state.commodityCategories ? (
            <div
                id="commodity_list_menu_box"
                className="commodity_list_menu"
                onMouseLeave={this.hide_commodity_menu}
            >
                <div className="commodity_category_menu_ul">
                    {this.state.commodityCategories.map((cItem, cIndex) => {
                        return (
                            <div
                                key={cIndex}
                                className="category_menu_li"
                                onMouseMove={() => this.debounce(this.header_move, 5, cIndex)}
                            >
                                <p
                                    className={`category_menu_li_name ${
                                        this.state.commodityMovediv === cIndex
                                            ? "category_menu_back"
                                            : null
                                        }`}
                                    id="category_menu_li_box"
                                >
                                    <span>{cItem.name}</span>
                                </p>
                            </div>
                        );
                    })}
                </div>
                {this.state.commodityState === false ? (
                    <div className="product_body">
                        {this.state.commodityNew.length === 0 ? null : product_new()}
                        {this.state.commodityList.length === 0
                            ? product_val()
                            : product_hot()}
                    </div>
                ) : (
                    <div className="product_body">{produc_child()}</div>
                )}
            </div>
        ) : null;
        return <div>{commodity_ele_list}</div>;
    }
}

export default Product;



// WEBPACK FOOTER //
// ./src/view/components/header/product.js